import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { API_URL } from 'src/environments/api-url';
import * as global from '../../../includes/global';



@Injectable({
  providedIn: 'root'
})
export class ManageMpisService {

  constructor(
    private _authService: AuthService,
    private http: HttpClient
  ) { }

  setMipReporting(mip_reporting) {
    const auth = {
      id: this._authService.currentUser._id,
      usertype: this._authService.currentUser.user_type,
      auth_key: this._authService.currentUser.auth_key,
    };
    const detail = {
      ...auth,
      mip_reporting
    }
    return this.http.post(global.url + API_URL.USER.setMipReporting, { details: detail });
  }
  setEnabledMips(enabled_mips) {
    const auth = {
      id: this._authService.currentUser._id,
      usertype: this._authService.currentUser.user_type,
      auth_key: this._authService.currentUser.auth_key,
    };
    const detail = {
      ...auth,
      enabled_mips
    }
    return this.http.post(global.url + API_URL.USER.setEnabledMips, { details: detail });
  }
  getMipsReportingsAndMeasures() {
    const auth = {
      id: this._authService.currentUser._id,
      usertype: this._authService.currentUser.user_type,
      auth_key: this._authService.currentUser.auth_key,
    };
    const detail = {
      ...auth,
    }
    return this.http.post(global.url + API_URL.USER.getMipsReportingsAndMeasures, { details: detail });
  }

}
